import { render } from "./SettingSecurity.vue?vue&type=template&id=6cf36fcf"
import script from "./SettingSecurity.vue?vue&type=script&lang=js"
export * from "./SettingSecurity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__